import { render, staticRenderFns } from "./BazarModal.vue?vue&type=template&id=0ac21d78&"
import script from "./BazarModal.vue?vue&type=script&lang=js&"
export * from "./BazarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports